/* Homepage-only Sowth mobile carousels. */
(function () {
  function initCarousel(root) {
    if (!root || root.__sowthCar) return;
    var track = root.querySelector('[data-track]');
    var nav = root.querySelector('[data-cnav]');
    if (!track || !nav) return;
    root.__sowthCar = true;
    var dotsWrap = nav.querySelector('[data-dots]');
    var prev = nav.querySelector('[data-prev]');
    var next = nav.querySelector('[data-next]');
    var mq = window.matchMedia('(max-width:749px)');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function itemOffset(i) {
      var c = track.children[i];
      if (!c) return 0;
      return c.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    }
    function pageStarts() {
      var n = track.children.length, cw = track.clientWidth,
          max = Math.max(0, track.scrollWidth - track.clientWidth), starts = [], i = 0, guard = 0;
      while (i < n && guard++ <= n + 1) {
        var start = Math.min(itemOffset(i), max);
        if (starts.length === 0 || start > starts[starts.length - 1] + 1) starts.push(start);
        if (start >= max - 1) break;
        var j = i + 1;
        while (j < n && itemOffset(j) + track.children[j].getBoundingClientRect().width <= start + cw + 1) j++;
        i = (j === i) ? i + 1 : j;
      }
      return starts.length ? starts : [0];
    }
    function cur(starts) {
      starts = starts || pageStarts();
      var sl = track.scrollLeft, best = 0, bd = Infinity;
      for (var i = 0; i < starts.length; i++) { var d = Math.abs(starts[i] - sl); if (d < bd) { bd = d; best = i; } }
      return best;
    }
    function update() {
      var starts = pageStarts(), c = cur(starts), ds = dotsWrap ? dotsWrap.children : [];
      for (var i = 0; i < ds.length; i++) ds[i].classList.toggle('is-on', i === c);
      if (prev) prev.disabled = c <= 0;
      if (next) next.disabled = c >= starts.length - 1;
    }
    function go(p) {
      var starts = pageStarts();
      p = Math.max(0, Math.min(starts.length - 1, p));
      track.scrollTo({ left: starts[p], behavior: reduce ? 'auto' : 'smooth' });
    }
    function build() {
      var overflow = track.scrollWidth > track.clientWidth + 2;
      if (!mq.matches || !overflow) { nav.classList.remove('is-active'); if (dotsWrap) dotsWrap.innerHTML = ''; return; }
      var starts = pageStarts(), n = starts.length;
      if (n <= 1) { nav.classList.remove('is-active'); if (dotsWrap) dotsWrap.innerHTML = ''; return; }
      nav.classList.add('is-active');
      if (dotsWrap && dotsWrap.childElementCount !== n) {
        dotsWrap.innerHTML = '';
        for (var i = 0; i < n; i++) {
          (function (idx) {
            var dot = document.createElement('button');
            dot.type = 'button'; dot.className = 'sowth-cnav__dot';
            dot.setAttribute('aria-label', 'Go to page ' + (idx + 1));
            dot.addEventListener('click', function () { go(idx); });
            dotsWrap.appendChild(dot);
          })(i);
        }
      }
      update();
    }
    if (prev) prev.addEventListener('click', function () { go(cur() - 1); });
    if (next) next.addEventListener('click', function () { go(cur() + 1); });
    var raf;
    track.addEventListener('scroll', function () { if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(build, 180); });
    if (mq.addEventListener) mq.addEventListener('change', build);
    window.addEventListener('load', build);
    build();
  }
  function initAll() {
    var roots = document.querySelectorAll('[data-carousel-root]');
    for (var i = 0; i < roots.length; i++) initCarousel(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
